import * as React from 'react'
import PropTypes from 'prop-types'
import { CardMedia } from '@mui/material'

const DEFAULT_PREVIEW = '/default-preview.jpg'

// Only DynamoDB-era rows (no game, no stored thumbnail, a source outside the uploads/ layout) have
// frames at the legacy storage path. Anything newer shows the default preview until its own
// thumbnail exists, so a processing card never flickers on a made-up URL.
const isLegacy = upload => Boolean(upload) &&
  !upload.gameId &&
  !upload.thumbnailUrl &&
  typeof upload.source === 'string' &&
  !/^s3:\/\/[^/]+\/uploads\//.test(upload.source)

const getThumbnail = upload => {
  if (!upload) {
    return DEFAULT_PREVIEW
  }

  if (upload.thumbnailUrl) {
    return upload.thumbnailUrl
  }

  if (!isLegacy(upload)) {
    return DEFAULT_PREVIEW
  }

  const source = upload.source
  const startingPercentage = Math.random() * 10
  const thumbnailIndex = Math.floor(startingPercentage)
  const name = source.substring(source.lastIndexOf('/') + 1, source.length)
  const separator = name.indexOf('-')
  if (separator < 1) {
    return DEFAULT_PREVIEW
  }

  const user = name.substring(0, separator)
  const file = name.substring(separator + 1, name.length)
  return `https://highlights-video-storage.s3.amazonaws.com/${user}/${file}.000000${thumbnailIndex}.jpg`
}

UploadCardMedia.propTypes = {
  upload: PropTypes.object,
  height: PropTypes.number
}

export default function UploadCardMedia (props) {
  const { upload, height = 300 } = props
  // Hovering shows another legacy frame; every other preview is one fixed image.
  const legacy = isLegacy(upload)

  const updatePreview = ev => {
    ev.target.src = getThumbnail(upload)
  }

  return (
    <>
      <CardMedia
        component="img"
        height={height}
        image={getThumbnail(upload)}
        onMouseOver={legacy ? updatePreview : undefined}
        onMouseOut={legacy ? updatePreview : undefined}
        onError={err => {
          if (!err.target.src.endsWith(DEFAULT_PREVIEW)) {
            err.target.src = DEFAULT_PREVIEW
          }
        }}
        sx={{ objectFit: 'cover' }}
        alt="Upload Preview"
      />
    </>
  )
}
